import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router';
import Dropzone from 'react-dropzone';

class UploadDocuments extends React.Component {
    constructor(props){
        super(props);
        this.state={
            result:[]
        }
    }
    render() {
        const spinner = (
            <div className="text-center">
                <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
                <span className="sr-only">Loading...</span>
            </div>
        );
        let roster;
        console.log("uploaded data here in new component");
        if (this.props.documents.length > 0) {
            if (this.props.documents.length > 1) {
                // Displaying a list of document names
                const documentList = this.props.documents.map((doc, index) => (
                    <p key={index}>{doc.document_name}</p>
                ));
                roster = (
                    <div>
                        {documentList}
                    </div>
                );
            } else {
                // Displaying a single document name if only one document is present
                roster = (
                    <div>
                        <p>{this.props.documents[0].document_name}</p>
                    </div>
                );
            }
        } else {
            let text;
            if (this.props.IsProcessing) {
                text = spinner;
            } else {
                text = (
                    <div className="text-center">
                        No documents are selected
                    </div>);
            }
            roster = (
                <div>
                    <Dropzone
                        className="overview-tab-panel-dropzone"
                        ref={(node) => { this.dropzone = node; }}
                        onDrop={this.props.onDrop}
                    >
                        <div>{text}</div>
                    </Dropzone>
                </div>
            );
        }
        return (
            <div className="col-sm-3 document-list">
                <Panel header="Documents">
                    {roster}
                    {/* <Button bsStyle="info">
                        <i className="fa fa-trash" /> Clear Documents
                    </Button> */}
                </Panel>
            </div>
        );
    }
}

export default UploadDocuments;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/UploadDocuments.js